import React, { useCallback, useEffect, useState } from "react";
import { Keyboard, Pressable, View, useWindowDimensions, TouchableOpacity, DeviceEventEmitter, VirtualizedList, RefreshControl, ActivityIndicator } from "react-native";
import { Theme, ThemeConsumer } from "@rneui/themed";
import { useFocusEffect } from "@react-navigation/native";
import Popover from "react-native-popover-view";
import * as Yup from 'yup'

import { config } from "../../shared/environment";
import { appColors } from "../../themes/appTheme";
//common Component
import CommonDialogBox from "../../shared/commonComponents/commonDialogBox";
import CommonService from "../../shared/services/commonService";
import { CustomModal } from "../../shared/commonComponents/customModal";

import { useAppNavigation, useAppRoute } from "../../types/@react-navigation/navigation";
import { useKeyborad } from "../../shared/hooks/useKeyborad";
//Module
import { CustomerListData, FilterPayload } from "./customerListModule";
//redux
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { deleteCustomer, getAllCustomerList, sendCustomerEmail, updateCustomerStatus } from "../../redux/slices/customerSlice";
//shared library
import { ZenBadge, ZenButton, ZenCheckBox, ZenDivider, ZenEmptyComponent, ZenFilterModal, ZenIcon, ZenLoader, ZenPopover, ZenSearchBar, ZenText, ZenToast } from "zen-core-elements";

import { filterItemsProps } from "zen-core-elements/src/elements/zenFilterModal/zenFilterType.modal";
import { getDefaultPOSRoles } from "../../redux/slices/commonSlice";
import { ListToolbar } from "../../shared/commonComponents/listToolbar";
import { SortProps } from "../products/productList/productModule";
import { showApiError } from '../../shared/utils/handleApiError';

//variable to store list customer limit value
let limit = 10
let alreadyExecuted = { active: false, inactive: false };
//variable to store filter payload
let filterPayload: { activeCustomer: string | null, InactiveCustomer: string | null } = { activeCustomer: null, InactiveCustomer: null }
const CustomerList = () => {
    const isKeyboardOpen = useKeyborad()
    const dispatch = useAppDispatch()
    const defaultPosRoles = useAppSelector((state) => state.common.defaultRoles)
    //Variable to store useRoute value
    const route = useAppRoute("Active Customer")
    const isActiveCustomer = route?.name == "Active Customer"
    const { count, loading, value: customerData } = useAppSelector((state) => state?.customer?.customerList[isActiveCustomer ? "active" : "inActive"])
    //Variable to store window dimension
    const { width } = useWindowDimensions();
    //variable to store useNavigation value
    const navigation = useAppNavigation()
    //State varaible is used to store the boolean value for the popover
    const [isVisibleSort, setIsVisibleSort] = useState<string | number>("")
    //variable to store filter count
    const [filtercount, setFilterCount] = useState(0)
    //variable to store selected filter
    const [isVisibleFilter, setIsVisibleFilter] = useState(false)
    //variable for handle refresh control
    const [listRefresh, setListRefresh] = useState(false)
    //variable for handle onEndReached
    const [footerLoader, SetFooterLoader] = useState(false)
    //variable to store offset value
    const [offset, setOffset] = useState<number>()
    //variable to store search value
    const [searchText, setSearchText] = useState<null | string>(null)
    //variable to handle delete popover
    const [deletePopoverVisible, setDeletePopoverVisible] = useState<{ isVisible: boolean, id: number | null }>({ isVisible: false, id: null })
    //variable to handle transparent loader
    const [transparentLoader, setTransparentLoader] = useState(false)
    //variable to store the toggle customer status dialog
    const toggleCustomerStatusDialogProps = (status: "activate" | "deactivate") => {
        return (
            {
                content: `Are you sure you want to ${status} this customer?`,
                button: [{ id: 1, name: "Okay" }, { id: 2, name: "Cancel" }],
                icon: {
                    name: 'alert-outline', size: 55, color: appColors.warning, type: 'material-community'
                }
            }
        )
    }
    const [customerStatusPopoverVisible, setcustomerStatusPopoverVisible] = useState<{ isVisible: boolean, status?: boolean, customerId?: number, dialogPros?: ReturnType<typeof toggleCustomerStatusDialogProps> }>({ isVisible: false })
    //variable to store options value
    const popoverOptionContent = [{ icon: "eye", name: "View Orders" },
    // { icon: "printer", name: "Print Membership Card" },
    { icon: "printer", name: "Print Customer" }, { icon: "account-cancel-outline", name: "Remove Customer" }]
    const [sortOptions, setSortOption] = useState<{ field: string, order: string, id: number } | null>(null)
    const sortOptionsData: SortProps[] = [
        { name: 'Customer name A-Z', id: 1, field: 'name', order: 'ASC' },
        { name: 'Customer name Z-A', id: 2, field: 'name', order: 'DESC' }
    ]
    const [selectedCustomer, setSelectedCustomer] = useState<Set<number>>(new Set([]))

    const yupValidation = Yup.object().shape({
        from: Yup.number()
            .typeError("Enter valid Input")
            .nullable()
            .transform((value, originalValue) =>
                originalValue.trim() === "" ? null : value
            )
            .min(
                0,
                `From range should start from 0`
            )
        ,
        to: Yup.number()
            .typeError("Enter valid Input")
            .nullable()
            .transform((value, originalValue) =>
                originalValue.trim() === "" ? null : value
            )
            .min(1, `To range should start from 1`)
            .when("from", (from, schema) => {
                return from && from[0] ?
                    schema.moreThan(
                        from[0],
                        "To range must be greater than From range"
                    ).required("This field is required") :
                    schema.test(
                        '',
                        'From is required',
                        (to) => {
                            return !from[0] && to ? false : true
                        }
                    )
            }
            ),
    })
    //variable to store filter history data
    const [filterData, setFilterData] = useState<filterItemsProps[]>([
        {
            id: "1",
            filterName: "Created Date",
            filterType: "dateRange",
            initialSelected: { startDate: "", endDate: "" },
            filterValue: { minDate: "", maxDate: "" }
        },
        {
            id: '2',
            filterName: 'Medium',
            filterType: "radio",
            filterValue: [
                {
                    value: 'WEB',
                    label: 'Admin',
                },
                {
                    value: 'POS',
                    label: 'POS',
                }
            ],
            initialSelected: ''
        },
        {
            id: '3',
            filterName: 'Status',
            filterType: "radio",
            filterValue: [
                {
                    value: 'Active',
                    label: 'Active',
                },
                {
                    value: 'Pending',
                    label: 'Pending',
                }
            ],
            initialSelected: ''
        },
        {
            id: '4',
            filterName: 'Customer Type',
            filterType: "radio",
            filterValue: [],
            initialSelected: ''
        },
        // {
        //     id: '5',
        //     filterName: 'Loyalty Amount Range',
        //     filterType: "inputRange",
        //     input: { keyboardType: "number-pad" },
        //     initialSelected: { from: "", to: "" },
        //     validation: yupValidation
        // },
        // {
        //     id: '6',
        //     filterName: 'On-account Limit Range',
        //     filterType: "inputRange",
        //     input: { keyboardType: "number-pad" },
        //     initialSelected: { from: "", to: "" },
        //     validation: yupValidation
        // },
    ])

    useEffect(() => {
        const eventListener = DeviceEventEmitter?.addListener("CUSTOMER_UPDATED", (event) => {
            if (route?.name == event?.routeName) {
                reInitializeStates()
            }
        })

        return () => {
            eventListener?.remove()
        }
    }, [route])

    //useFocusEffect hook for getting current screen name  
    useFocusEffect(
        useCallback(() => {
            if (!alreadyExecuted[isActiveCustomer ? "active" : "inactive"]) {
                toggleOffsetValue()
                alreadyExecuted[isActiveCustomer ? "active" : "inactive"] = true
            }
        }, [isActiveCustomer])
    );

    //useEffect when offset is change
    useEffect(() => {
        if (offset != undefined) {
            getAllCustomerListApi()
        }
    }, [offset])

    //useEffect when sort option change
    useEffect(() => {
        if (sortOptions !== null) {
            toggleOffsetValue()
        }
    }, [sortOptions])

    //useEffect triggered  when search data changes
    useEffect(() => {
        if (searchText != null) {
            const debounceSearchText = setTimeout(() => {
                toggleOffsetValue()
            }, 1000);
            return () => { clearTimeout(debounceSearchText) }
        }
    }, [searchText])

    //Method for toggle offset value
    const toggleOffsetValue = () => {
        setOffset((preset) => (preset === 0 ? -1 : 0))
    }
    //Method for get all customer list
    const getAllCustomerListApi = async () => {
        const sortOptionPayload = [[["name", "ASC"]], [["name", "DESC"]]]
        let payloadFilterData = filterPayload[isActiveCustomer ? "activeCustomer" : "InactiveCustomer"] || ""
        let isWholeSaleCustomer = payloadFilterData ? JSON.parse(payloadFilterData)?.isWholeSale || false : false
        if (isWholeSaleCustomer) {
            let tempData = JSON.parse(payloadFilterData)
            delete tempData.isWholeSale
            payloadFilterData = JSON.stringify(tempData)
        }
        await dispatch(getAllCustomerList({
            storeId: config?.storeId,
            data: {
                isActive: isActiveCustomer,
                searchText: searchText ? searchText : null,
                offset: offset != -1 ? offset : 0,
                limit: limit,
                sort: JSON.stringify(sortOptionPayload[sortOptions?.id ? (sortOptions?.id - 1) : 0]),
                ...isWholeSaleCustomer && { isWholesale: true },
                filterData: payloadFilterData
            }
        })).unwrap().catch(showApiError).finally(() => {
            setListRefresh(false)
            SetFooterLoader(false)
        })
    }

    //Method for delete customer
    const deleteCustomerApi = async (userId: number | number[]) => {
        await dispatch(deleteCustomer({ storeId: config?.storeId, userId })).unwrap().then((response) => {
            if (response) {
                setSelectedCustomer(new Set([]))
                // toggleOffsetValue()
                ZenToast({ type: "success", message: "Customer deleted successfully" })
            } else {
                ZenToast({ type: "error", message: "Faild to delete customer" })
            }
        }).catch((error) => {
            ZenToast({ type: "error", message: "Faild to delete customer, please try again after some time!!" })
            console?.log("Delete customer api error", error)
        }).finally(() => {
            setTransparentLoader(false)
        })
    }

    const sendEmail = async (customerId: number) => {
        setTransparentLoader(true)
        await dispatch(sendCustomerEmail({ customerId, storeId: config?.storeId })).unwrap().then((response) => {
            if (response.success) {
                ZenToast({ type: "success", message: "Email successfully sent to the customer" })
            }
        }).catch((error) => {
            ZenToast({ type: "error", message: "Faild to sent a email to the customer." })
            console?.log("Delete customer api error", error)
        }).finally(() => {
            setTransparentLoader(false)
        })
    }
    //method for handle options
    const otherOptions = (option: string, customer: CustomerListData) => {
        switch (option) {
            case 'Print Customer':
                setIsVisibleSort("")
                navigation.navigate("PrintCustomer", { customerHistoryData: customer })
                break;
            case 'Customer History':
                setIsVisibleSort("")
                navigation.navigate("CustomerHistory", { customerHistoryData: customer })
                break;
            case 'Print Membership Card':
                setIsVisibleSort("")
                navigation.navigate("PrintMembershipCard", { customerId: customer?.customerId })
                break;
            case 'Remove Customer':
                setIsVisibleSort("")
                setTimeout(() => {
                    setDeletePopoverVisible({ isVisible: true, id: customer?.userId })
                }, 1000);
                break;
            case 'Deactivate Customer':
                setIsVisibleSort("")
                setTimeout(() => {
                    setcustomerStatusPopoverVisible({ isVisible: true, customerId: customer?.userId, status: false, dialogPros: toggleCustomerStatusDialogProps("deactivate") })
                }, 1000);
                break;
            case 'Activate Customer':
                setIsVisibleSort("")
                setTimeout(() => {
                    setcustomerStatusPopoverVisible({ isVisible: true, customerId: customer?.userId, status: true, dialogPros: toggleCustomerStatusDialogProps("activate") })
                }, 1000);
                break;
            case 'View Orders':
                setIsVisibleSort("")
                navigation.navigate("OrdersStack", { screen: "OrderList", params: { customerId: customer?.customerId } })
                break;
            case 'Send Email':
                setIsVisibleSort("")
                sendEmail(customer?.userId)
                break;
        }
    }

    const toggleCustomer = async () => {
        const { customerId = 0, status = true } = customerStatusPopoverVisible!!
        await dispatch(updateCustomerStatus({ storeId: config.storeId, customerId, isActive: status })).unwrap().then((response) => {
            // toggleOffsetValue()
        })
    }
    const toggleCustomerConfirmation = (value: { id: number }) => {
        setcustomerStatusPopoverVisible((prev) => ({ ...prev, isVisible: false }))
        if (value?.id == 1) {
            toggleCustomer()
        }
    }

    //method for popover confirmation 
    const confirmation = (item: { id: number }) => {
        let id = deletePopoverVisible?.id || (selectedCustomer?.size > 1 ? [...selectedCustomer] : [...selectedCustomer][0])
        setDeletePopoverVisible({ isVisible: false, id: null })
        if (item?.id == 2) {
            setTransparentLoader(true)
            deleteCustomerApi(id)
        }
    }
    const createCustomer = () => {
        navigation.navigate("AddEditCustomer", { routeName: route?.name })
    }

    const convertCapitalLetter = (str: string) => {
        return str[0].toUpperCase() + str.slice(1)
    }
    useEffect(() => {
        if (defaultPosRoles) {
            setFilterData((prev) => {
                let data = [...prev]
                if (data[3].filterType == "radio" && !data[3].filterValue?.length) {
                    defaultPosRoles.forEach((item) => {
                        data[3].filterType == "radio" && data[3].filterValue.push({
                            value: item.id.toString(),
                            label: convertCapitalLetter(item?.name)
                        })
                    })
                    data[3].filterType == "radio" && data[3].filterValue.push({
                        value: "-1",
                        label: "Wholesale customer"
                    })
                }
                return [...data]
            })
        }
    }, [defaultPosRoles])

    const openFilterModal = () => {
        if (!defaultPosRoles) {
            setTransparentLoader(true)
            dispatch(getDefaultPOSRoles({ storeId: config.storeId })).unwrap().then((response) => {
                if (response?.success) {
                    setIsVisibleFilter(true)
                } else {
                    ZenToast({ type: "error", message: "Failed to get a default roles" })
                }
            }).catch((error) => {
                ZenToast({ type: "error", message: "Failed to get a default roles" })
            }).finally(() => {
                setTransparentLoader(false)
            })
        } else {
            setIsVisibleFilter(true)
        }
    }

    const Template = ({ label, value, color }: { label: string, value: string, color?: string }) => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    <View style={[width > 600 ? { gap: 5, alignItems: "flex-start" } : { flexDirection: "row", alignItems: "center", gap: 5 }]}>
                        <ZenText content={label + (width < 600 ? ":" : "")} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
                        <ZenText content={value} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: color || theme?.lightDark }} />
                    </View>
                )}
            </ThemeConsumer>
        )
    }

    const handleCheckbox = (id: number, selectAll?: boolean) => {
        if (id !== -1) {
            setSelectedCustomer((prev) => {
                let data = new Set([...prev])
                if (data.has(id)) {
                    data.delete(id)
                } else {
                    data.add(id)
                }
                return data
            })
        } else {
            let selectedCustomers: Set<number> = new Set([])
            if (selectAll) {
                customerData?.forEach((item) => selectedCustomers.add(item?.userId))
            }
            setSelectedCustomer(selectedCustomers)
        }
    }
    const popoverContent = useCallback((user: CustomerListData["user"]) => {
        let data: { icon: string, name: string }[] = []
        if (width < 600) {
            if (user?.isActive) {
                data.push({ icon: 'close-circle-outline', name: "Deactivate Customer" })
            } else {
                data.push({ icon: "check-circle", name: "Activate Customer" })
            }
        }
        if (width < 900) {
            data.push({ icon: "history", name: "Customer History" })
        }
        if (!user?.isUserVerified && !!user?.email) {
            data.push({ icon: "mail", name: "Send Email" })
        }
        data.push(...popoverOptionContent)
        return data
    }, [width])

    const renderItem = ({ item, index }: { item: CustomerListData[], index: number }) => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    <View key={index} style={{ flexDirection: "row" }}>
                        {item?.map((customer: CustomerListData, ResponseDataIndex: number) => (
                            <View key={ResponseDataIndex} style={{ flex: 1 }}>
                                <Pressable style={[{
                                    marginBottom: 10,
                                    marginHorizontal: 10,
                                    padding: 10,
                                    borderRadius: 5,
                                    backgroundColor: theme.light
                                }, width < 600 && selectedCustomer?.has(customer?.userId) && { borderWidth: 1, borderColor: theme?.grey }]}
                                    onLongPress={() => handleCheckbox(customer?.userId)}
                                    onPress={() => {
                                        if (width > 600 || (width < 600 && selectedCustomer?.size))
                                            handleCheckbox(customer?.userId)
                                    }}
                                >
                                    <View style={{ flexDirection: "row", alignItems: "flex-start", gap: 10 }}>
                                        <View style={{ display: width > 600 ? "flex" : "none" }}>
                                            <ZenCheckBox
                                                containerStyle={{ backgroundColor: "transparent" }}
                                                checkedColor={theme.primary}
                                                onPress={() => {
                                                    handleCheckbox(customer?.userId)
                                                }}
                                                checked={selectedCustomer?.has(customer?.userId)}
                                                size={24}
                                            />
                                        </View>
                                        <View style={{ flex: 1, gap: 10 }}>
                                            <View style={{ flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap" }}>
                                                <View style={{ gap: 5, width: "50%" }}>
                                                    <View style={{ flexDirection: "row", alignItems: "center", gap: 5 }}>
                                                        <ZenText content={customer?.user.name} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark }} />
                                                        <ZenBadge
                                                            badgeName={customer?.medium}
                                                            badgeColor={customer?.medium == "POS" ? theme?.customerStatus?.wholesaleStatus : theme?.customerStatus?.typeWholesalecolor}
                                                            badgeTextColor={theme?.light}
                                                            badgeTextSize={"small"}
                                                            badgeTextStyle={{ fontFamily: theme?.bold, padding: 2 }}
                                                        />
                                                    </View>
                                                    {customer.user.phone && customer?.countryCode &&
                                                        <ZenText content={"+" + customer?.countryCode + " " + customer.user.phone} color={theme.grey} size={theme.smallFontSize} />}
                                                </View>
                                                <View style={{ gap: 5 }}>
                                                    <ZenBadge
                                                        badgeName={customer?.user?.isActive ? "Active" : customer?.user?.isActive == null ? "Pending" : "In active"}
                                                        badgeColor={customer?.user?.isActive ? theme?.customerStatus?.activeOrApprovedStatus : customer?.user?.isActive == null ? theme.customerStatus.pendingStatus : theme?.customerStatus?.declinedStatus}
                                                        badgeTextColor={theme.light}
                                                        badgeTextSize={"small"}
                                                        badgeContainerStyle={{ alignSelf: "flex-end" }}
                                                        badgeTextStyle={{ fontFamily: theme.bold }}
                                                    />
                                                    <ZenText content={customer.user.email || "---"} color={theme.grey} size={theme.smallFontSize} />
                                                </View>
                                            </View>
                                            <ZenDivider style={{ height: 0.6, backgroundColor: theme?.lightGrey }} />
                                            <View style={[width > 600 && { alignItems: "center" }, { flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between" }]}>
                                                <View style={[width > 600 && { flexDirection: "row", justifyContent: "space-between", width: "75%" }, { gap: 10 }]}>
                                                    <Template label="WholeSale" value={customer?.isWholesale ? "Approved" : "N/A"} color={theme?.green} />
                                                    {/* <Template label="On-Account" value={CommonService?.currencyStandard("₹", customer?.accountLimitValue?.toString() || "0")} /> */}
                                                    {/* <Template label="Loyalty" value={customer?.balancePoints || "0"} /> */}
                                                    <Template label="Type" value={customer?.isWholesale ? "Wholesale" : customer?.role?.role || "Nil"} />
                                                    <Template label="Location" value={customer?.addresses?.city || "---"} />
                                                </View>
                                                <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
                                                    <TouchableOpacity onPress={() => {
                                                        navigation.navigate("AddEditCustomer", { customerId: customer?.customerId, routeName: route?.name, isUserVerified: customer?.user?.isUserVerified, userId: customer?.userId })
                                                    }}>
                                                        <ZenIcon
                                                            name='pencil'
                                                            type='octicon'
                                                            color={theme?.iconColor}
                                                            size={theme?.iconSize}
                                                            style={{
                                                                "padding": 10,
                                                                "backgroundColor": theme.lightBackgroundColor,
                                                                "borderRadius": 10
                                                            }}
                                                        />
                                                    </TouchableOpacity>
                                                    <TouchableOpacity onPress={() => {
                                                        setcustomerStatusPopoverVisible({
                                                            isVisible: true,
                                                            customerId: customer?.userId,
                                                            status: customer?.user?.isActive ? false : true,
                                                            dialogPros: toggleCustomerStatusDialogProps(customer?.user?.isActive ? "deactivate" : "activate")
                                                        })
                                                    }}>
                                                        <ZenIcon
                                                            type="material-community"
                                                            name={customer?.user?.isActive ? 'close-circle-outline' : 'check-circle'}
                                                            size={theme?.iconSize}
                                                            color={customer?.user.isActive ? theme?.red : theme.activeColor}
                                                            style={{
                                                                "padding": 10,
                                                                "backgroundColor": theme.lightBackgroundColor,
                                                                "borderRadius": 10
                                                            }}
                                                        />
                                                    </TouchableOpacity>
                                                    {width > 900 ? <TouchableOpacity onPress={() => {
                                                        navigation.navigate("CustomerHistory", { customerHistoryData: customer })
                                                    }}>
                                                        <ZenIcon
                                                            type="material-community"
                                                            name={"history"}
                                                            size={theme?.iconSize}
                                                            color={theme.iconColor}
                                                            style={{
                                                                "padding": 10,
                                                                "backgroundColor": theme.lightBackgroundColor,
                                                                "borderRadius": 10
                                                            }}
                                                        />
                                                    </TouchableOpacity> : <></>}
                                                    <ZenPopover
                                                        RenderContent={() => <View style={theme?.customerListStyle?.popoverView}>
                                                            {popoverContent(customer?.user)?.map((option, index) => (
                                                                <Pressable key={index}
                                                                    onPress={() => { otherOptions(option?.name, customer) }}
                                                                    style={[theme?.customerListStyle?.optionListView, {
                                                                        borderTopWidth: index == 0 ? 0 : 0.34,
                                                                        paddingTop: index == 0 ? 0 : 5,

                                                                    }]}>
                                                                    <ZenIcon type="material-community" name={option?.icon} size={theme?.iconSize} color={theme?.grey} style={{ paddingRight: 10 }} />
                                                                    <ZenText content={option?.name} color={theme.lightDark} size={width > 600 ? "medium" : theme?.smallerFontSize} />
                                                                </Pressable>
                                                            ))}
                                                        </View>}
                                                        isVisible={isVisibleSort == customer?.customerId}
                                                        onRequestClose={() => setIsVisibleSort("")}
                                                        from={
                                                            <TouchableOpacity onPress={() => {
                                                                setIsVisibleSort(customer?.customerId)
                                                            }}>
                                                                <ZenIcon
                                                                    type="material-community" name={'dots-horizontal'}
                                                                    size={theme?.iconSize}
                                                                    color={theme.iconColor}
                                                                    style={{
                                                                        "padding": 10,
                                                                        "backgroundColor": theme.lightBackgroundColor,
                                                                        "borderRadius": 10
                                                                    }}
                                                                />
                                                            </TouchableOpacity>}
                                                    />
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </Pressable>
                            </View>
                        ))}
                    </View>
                )}
            </ThemeConsumer>
        )
    }

    const getItem = (item: any[], index: number) => {
        let array: any = [];
        let numOfColumns = 1
        for (let i = 0; i < numOfColumns; i++) {
            let temp = item?.[index * numOfColumns + i];
            temp && array?.push(temp);
        }
        return array;
    };

    const footerComponent = () => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    footerLoader ?
                        <View>
                            <ActivityIndicator size={"small"} color={theme?.primary} />
                        </View >
                        : undefined
                )}
            </ThemeConsumer>
        )
    }

    const reInitializeStates = () => {
        filterPayload[isActiveCustomer ? "activeCustomer" : "InactiveCustomer"] = null
        DeviceEventEmitter?.emit(isActiveCustomer ? "activeCustomer" : "inactiveCustomer")
        setSelectedCustomer(new Set([]))
        setSearchText(null)
    }

    const onRefresh = () => {
        setListRefresh(true)
        reInitializeStates()
        toggleOffsetValue()
    }
    const onEndReached = () => {
        if ((count > (offset || 0)) && !footerLoader) {
            SetFooterLoader(true)
            setOffset((prev) => (prev == -1 ? (limit + (prev + 1)) : (limit + (prev || 0))))
        }
    }
    return (
        <ThemeConsumer>
            {({ theme }: { theme: Theme }) => (
                <View style={theme.productListStyle.containerView}>
                    <View style={{ flex: 1 }}>
                        {/* <View onStartShouldSetResponder={() => { Keyboard?.dismiss(); return false }} style={{ flexDirection: "row", justifyContent: "space-between", marginHorizontal: 10, gap: 10, alignItems: "center" }}>
                            <View style={{ flex: 1 }}>
                                <ZenSearchBar
                                    search={searchText || ""}
                                    setSearch={(prev) => { setSearchText(prev as string) }}
                                    onCancel={() => { setSearchText(null); toggleOffsetValue(); Keyboard?.dismiss() }}
                                    placeholder={"Search by name, Phone number"}
                                    placeholderTextColor={theme.lightDark}
                                    searchContainerStyle={{
                                        "backgroundColor": theme.light,
                                        "height": 45,
                                        "paddingHorizontal": 10,
                                        "borderRadius": 20,
                                    }}
                                    searchInputStyle={{
                                        top: -3,
                                        "color": theme.lightDark,
                                        "fontSize": theme.smallFontSize,
                                        "fontFamily": theme.medium,
                                        "paddingLeft": 15
                                    }}
                                />
                            </View>
                            <Pressable style={[{
                                padding: 8.5,
                                borderRadius: 6,
                                borderWidth: 0.4,
                                borderColor: theme?.grey
                            }]} onPress={() => setSortOption((prev) => [1, 0][prev || 0])}>
                                <ZenIcon type="material-community" name={'sort'} size={theme?.iconSize} color={theme?.grey} />
                            </Pressable>
                            <TouchableOpacity onPress={openFilterModal}
                                style={[{
                                    padding: 8.5,
                                    borderRadius: 6,
                                    borderWidth: 0.4,
                                    borderColor: theme?.grey
                                }]}>
                                {filtercount ?
                                    <ZenBadge
                                        badgeName={filtercount.toString()}
                                        badgeColor={theme?.primary}
                                        badgeTextColor={theme.light}
                                        badgeTextSize={"small"}
                                        badgeContainerStyle={{ position: "absolute", right: -7, top: -7, paddingHorizontal: 7 }}
                                    />
                                    : null}
                                <ZenIcon name='filter-variant' type='material-community' size={theme?.iconSize} />
                            </TouchableOpacity>
                            {width > 600 &&
                                <ZenButton
                                    title="Add Customer"
                                    titleStyle={{ fontSize: theme.errorFontSize, fontFamily: theme.bold }}
                                    onPress={createCustomer}
                                    buttonStyle={{
                                        backgroundColor: theme?.primary,
                                        borderRadius: 10,
                                        padding: 1
                                    }}
                                />}
                        </View> */}
                        <ListToolbar
                            search={{
                                value: searchText ?? "",
                                onChange: (val) => { setSearchText(val as string) },
                                onCancel: () => { setSearchText(null); toggleOffsetValue(); Keyboard?.dismiss() },
                                placeholder: 'Search by Customer name',
                            }}
                            filter={{
                                count: filtercount ?? 0,
                                onPress: () => openFilterModal(),
                            }}
                            sort={{
                                // selectedId: sortOptions,
                                // onSelect: (item) => setSortOption((prev) => [1, 0][prev || 0]),
                                selectedId: sortOptions?.id,
                                onSelect: (item) => setSortOption(item as { field: string, order: string, id: number }),
                                title: 'Sort by',
                                options: sortOptionsData
                            }}
                            buttons={[{
                                onPress: () => createCustomer(),
                                title: 'Create Customer',
                                variant: "primary"
                            }]}
                        />
                        {(loading && !listRefresh && !footerLoader) ?
                            <ZenLoader lottie={require('../../assets/infinityLoader.json')} lottieType='Local' viewStyle={{ backgroundColor: "transparent" }} /> :
                            <View style={{ flex: 1 }}>
                                <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingHorizontal: 10, display: selectedCustomer?.size ? "flex" : "none", paddingBottom: 10 }}>
                                    <ZenCheckBox
                                        title={selectedCustomer?.size === customerData.length ? "DeSelect All" : "Select All"}
                                        titleStyle={{ fontSize: theme.smallerFontSize }}
                                        containerStyle={{ marginLeft: 5, backgroundColor: "transparent" }}
                                        checkedColor={theme.primary}
                                        onPress={() => {
                                            if (selectedCustomer?.size === customerData.length)
                                                handleCheckbox(-1, false)
                                            else
                                                handleCheckbox(-1, true)
                                        }}
                                        checked={selectedCustomer?.size === customerData.length}
                                        size={20}
                                    />
                                    <TouchableOpacity style={theme?.customerListStyle?.optionInnerContainer} onPress={() => { setDeletePopoverVisible({ isVisible: true, id: null }) }}>
                                        <ZenText content={'Delete'} bold style={[theme?.customerListStyle?.optionTextStyle, { color: theme?.red }]} />
                                    </TouchableOpacity>
                                </View>
                                <VirtualizedList
                                    keyExtractor={(_: any, index: number) => index?.toString()}
                                    getItemCount={(data: any) => data?.length}
                                    getItem={getItem}
                                    scrollEnabled={true}
                                    nestedScrollEnabled={true}
                                    renderItem={renderItem}
                                    data={customerData || []}
                                    keyboardDismissMode="on-drag"
                                    showsVerticalScrollIndicator={false}
                                    onEndReachedThreshold={0.01}
                                    contentContainerStyle={[{ paddingBottom: customerData.length ? 10 : undefined, flex: customerData?.length ? undefined : 1 }]}
                                    ListFooterComponent={footerComponent}
                                    ListFooterComponentStyle={{ height: customerData.length ? 70 : 0 }}
                                    ListEmptyComponent={<ZenEmptyComponent viewStyle={{ backgroundColor: theme?.light }} />}
                                    onEndReached={onEndReached}
                                    refreshControl={<RefreshControl refreshing={listRefresh} onRefresh={onRefresh} />}
                                />
                            </View>
                        }
                    </View>
                    <ZenFilterModal
                        filterName={isActiveCustomer ? "activeCustomer" : "inactiveCustomer"}
                        setVisible={setIsVisibleFilter}
                        visible={isVisibleFilter}
                        filterItems={filterData}
                        setFilterItems={setFilterData}
                        filterCount={filtercount}
                        setFilterCount={setFilterCount}
                        title="Customer List Filter"
                        isSingleExpand={false}
                        onConfirm={(val) => {
                            let data: FilterPayload = {}
                            if (val?.values?.["Medium"]) {
                                data["medium"] = val?.values?.["Medium"]
                            }
                            if (val?.values?.["Created Date"] && val?.values?.["Created Date"]?.startDate && val?.values?.["Created Date"]?.endDate) {
                                data["customDateRange"] = { begin: val?.values?.["Created Date"]?.startDate, end: val?.values?.["Created Date"]?.endDate }
                            }
                            if (val.values.Status) {
                                data.status = val.values.Status
                            }
                            if (val.values?.["Customer Type"]) {
                                const customerType = val.updatedFilters[3]
                                if (customerType.filterType == "radio") {
                                    customerType.filterValue?.forEach((item) => {
                                        if (item?.value == customerType?.initialSelected) {
                                            if (item?.label == "Wholesale customer") {
                                                let wholesaleData = customerType.filterValue.filter((subItem) => subItem?.label === "Customer")
                                                data.roleId = Number(wholesaleData[0].value)
                                                data.type = wholesaleData[0].label
                                                data.isWholeSale = true
                                            }
                                            else {
                                                data.roleId = Number(item?.value)
                                                data.type = item?.label?.split(" ")[0]
                                            }
                                        }
                                    })
                                }
                            }
                            let loyaltyRange = val?.values?.['Loyalty Amount Range']
                            if (loyaltyRange && loyaltyRange?.from && loyaltyRange?.to) {
                                data.loyaltyRange = { start: loyaltyRange?.from, end: loyaltyRange?.to }
                            }
                            let accountRange = val?.values?.['On-account Limit Range']
                            if (accountRange && accountRange?.from && accountRange?.to) {
                                data.accountLimitRage = { start: accountRange?.from, end: accountRange?.to }
                            }
                            filterPayload[isActiveCustomer ? 'activeCustomer' : "InactiveCustomer"] = JSON?.stringify(data)
                            toggleOffsetValue()
                        }
                        }
                    />
                    {
                        width < 600 && !isKeyboardOpen &&
                        <Pressable style={{ position: "absolute", backgroundColor: theme.primary, width: 50, height: 50, borderRadius: 32, bottom: 40, right: 40, justifyContent: 'center', alignItems: "center" }} onPress={createCustomer}>
                            <ZenIcon type="material-community" name={"plus"} size={24} color={theme.light} />
                        </Pressable>
                    }
                    {/* For toggle customer confirmation */}
                    <Popover isVisible={customerStatusPopoverVisible?.isVisible} popoverStyle={{ width: width > 600 ? 400 : 300, borderRadius: 10, zIndex: 10 }}>
                        <CommonDialogBox type="OTHER" dialog={customerStatusPopoverVisible?.dialogPros!!} confirmation={toggleCustomerConfirmation} />
                    </Popover>
                    {/* For delete confirmation */}
                    <Popover isVisible={deletePopoverVisible?.isVisible} popoverStyle={{ width: width > 600 ? 400 : 300, borderRadius: 10, zIndex: 10 }}>
                        <CommonDialogBox type="DELETE" replaceValue={selectedCustomer?.size > 1 ? "customers" : "customer"} confirmation={confirmation} />
                    </Popover>
                    <CustomModal visible={transparentLoader} transparent>
                        <ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={theme?.primary} lottieType="Local" lottie={require('../../assets/infinityLoader.json')} />
                    </CustomModal>
                </View>
            )
            }
        </ThemeConsumer >

    )
}

export default CustomerList